import TextContainer from "@client/content/Containers/Text/container";
import { RedirectLinkEntity } from "@client/content/controls/Link/Redirect/container";
import { getContainerProps, getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type HeadingProps } from "@client/controls/HTML/Heading/component";
import * as React from "react";

import "./style.less";

export type TitleComponentProps = RootContainerProps & {
  className: string;
  headingProps: HeadingProps;
  title: string;
};

export default (props: TitleComponentProps) => (
  <TextContainer className="wsc_content_title" {...getContainerProps(props)}>
    <RedirectLinkEntity {...getEntityRef(props)}>
      <props.TextComponent
        {...getEntityRef(props)}
        className={props.className}
        toolbar={"basic"}
        prop="title"
        style={props.headingProps.style}
        tag={props.headingProps.level}
        html={props.title}
      />
    </RedirectLinkEntity>
  </TextContainer>
);
